import { Flex, Button } from 'antd';
import { spacing } from '../../theming';
import { useMedia } from '../../hooks/useMediaQuery';
import { AnimatePresence, motion } from 'framer-motion';

export default function ListControlButtons({ index, t, handleAdd, handleRemove, statusList }) {
    const { isSmallDevice } = useMedia();
    return (
        <Flex gap={spacing[4]}>
            <Button
                type="text"
                onClick={handleAdd}
                style={{
                    padding: isSmallDevice && spacing[0.5],
                }}
            >
                <i className="fi-rr-add" style={{ marginTop: spacing[0.5] }} />
                {t('form.add')}
            </Button>

            <AnimatePresence>
                {statusList.length > 1 && (
                    <motion.div
                        key="remove-button"
                        initial={{ opacity: 0, y: -10 }} // Start slightly offscreen
                        animate={{ opacity: 1, y: 0 }} // Fade in and slide in
                        exit={{ opacity: 0, y: -10 }} // Fade out and slide out
                        transition={{ duration: 0.3 }} // Animation duration
                    >
                        <Button
                            type="text"
                            onClick={() => handleRemove(index)}
                            style={{
                                padding: isSmallDevice && spacing[0.5],
                            }}
                        >
                            <i className="fi-rr-trash" style={{ marginTop: spacing[0.5] }} />
                            {t('form.remove')}
                        </Button>
                    </motion.div>
                )}
            </AnimatePresence>
        </Flex>
    );
}
